import MainLayout from "@/components/PatientLayout/MainLayout";

const PatientContact = () => {
  return (
    <MainLayout>
      <div className="pb-10">
        <div className=" text-xl font-bold">CONTACT US</div>
        <p className="mt-4">
          If you have questions about your account and for technical support, please email us at
          <b> support@medmonk.com </b>
          or call us at
          <b> 1-866-ADHERE2 (501-8040)</b>
        </p>
      </div>
    </MainLayout>
  )
}

export default PatientContact